import { render, staticRenderFns } from "./Barcode-Setting.vue?vue&type=template&id=4387af8e&scoped=true"
import script from "./Barcode-Setting.vue?vue&type=script&lang=js"
export * from "./Barcode-Setting.vue?vue&type=script&lang=js"
import style0 from "./Barcode-Setting.vue?vue&type=style&index=0&id=4387af8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387af8e",
  null
  
)

export default component.exports